import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "searchBox" }
const _hoisted_2 = { class: "pageContent" }
const _hoisted_3 = { class: "searchCount" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "itemHead"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "itemPath"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "searchPagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_head = _resolveComponent("page-head")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Footer1 = _resolveComponent("Footer1")!
  const _component_Footer2 = _resolveComponent("Footer2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_head, { onSearchValue: _ctx.searchValue }, null, 8, ["onSearchValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, "共搜索到 " + _toDisplayString(_ctx.pagination.total) + " 个与 " + _toDisplayString(_ctx.filterMe) + " 相关的结果", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_ctx.handleToArticle(item)),
            class: "searchItem",
            key: index
          }, [
            (item.current.type==1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["iconfont itemIcon", 'itemIcon'+item.type]),
                    innerHTML: item.icon
                  }, null, 10, _hoisted_6),
                  _createElementVNode("span", {
                    innerHTML: item.current?.name
                  }, null, 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "itemMes",
              innerHTML: item.current.type==1?item.content:item.current.docDescribeUnformatted
            }, null, 8, _hoisted_8),
            (item.current.type==1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.path, (one, i) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: one.id,
                      style: _normalizeStyle({'color':item.current?.id==one.id?'#2A61EC':'#666'})
                    }, [
                      _createTextVNode(_toDisplayString(one.name), 1),
                      (item.path.length!=i+1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " > "))
                        : _createCommentVNode("", true)
                    ], 4))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_pagination, {
            "hide-on-single-page": _ctx.pagination.total<=_ctx.pagination.size,
            currentPage: _ctx.pagination.current,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.current) = $event)),
            "page-size": _ctx.pagination.size,
            total: _ctx.pagination.total,
            "page-sizes": [5, 10, 20],
            background: "",
            layout: "total,prev, pager, next,sizes",
            class: "mt-4",
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["hide-on-single-page", "currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ])
      ])
    ]),
    (_ctx.platformJson.type=='paas')
      ? (_openBlock(), _createBlock(_component_Footer1, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.platformJson.type=='yj')
      ? (_openBlock(), _createBlock(_component_Footer2, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}